import PdaTitle from '../../component/common/PdaTitle'
import React, { useContext, useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { Button } from 'primereact/button'
import { useLocation, useNavigate } from 'react-router-dom'
import { InventorySupplementDetail } from '../../types/inventory'
import { map } from 'lodash'
import moment from 'moment'
import InventorySupplementScanDialog from '../../component/inventory/InventorySupplementScanDialog'
import { CommonContext } from '../../component/common/context/commonContext'
import InventorySupplementQuantityDialog from '../../component/inventory/InventorySupplementQuantityDialog'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'
import { translateLocationType } from "../../utils/translateCodeUtils";

const InventorySupplementScan = () => {
    const { $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    const [scanVisible, setScanVisible] = useState<boolean>(false)
    const [supplementQuantityVisible, setSupplementQuantityVisible] = useState<boolean>(false)

    const detail: InventorySupplementDetail = location.state.detail

    useMountEffect(() => {
        console.log('재고 보충 상세', detail)
    })

    const onclickScan = () => {
        setSupplementQuantityVisible(true)
    }

    const onclickScanDestination = () => {
        setScanVisible(true)
    }

    const onclickCancel = async () => {
        const isConfirm = await $alert({
            icon: 'warn',
            title: t(tokens.common.inventory_replenishment_cancellation),
            text: t(tokens.inventory.confirm_inventory_replenishment_cancellation),
            isConfirm: true,
        })

        if (isConfirm) {
            let result = await $http().delete(`/inventory/supplement/cancel/${detail.inventorySupplementSeq}`)

            if (result === 204) {
                await $alert({
                    icon: 'info',
                    title: t(tokens.common.inventory_replenishment_cancellation),
                    text: t(tokens.inventory.replenishment_cancellation_successful),
                    isConfirm: false,
                })
                navigate('/inventory-supplement')
            }
        }
    }

    return (
        <div>
            <PdaTitle title={t(tokens.common.inventory_replenishment_details)} historyBack goToHome />
            <div className="flex grid w-full m-0">
                <div className="col-12 flex font-bold text-lg text-left ml-2 pt-3 pb-0">{t(tokens.common.product_info)}</div>
                <div className="card w-full m-2 mb-1 p-1 pb-2">
                    <div className="col-12 pb-1 flex text-xl font-bold text-color-blue">{t(tokens.common.product_name)} | {t(tokens.common.product_barcode)}</div>
                    <div className="col-12 p-0 pl-2 flex text-md font-semibold">{detail.goodsNm} | {detail.sysCd}</div>
                    <div className="col-12 pb-1 pt-3 flex text-xl font-bold text-color-blue">
                        {t(tokens.common.quantity)} | {t(tokens.common.specification)}
                    </div>
                    <div className="col-12 p-0 pl-2 flex text-md font-semibold">
                        {detail.splmQty ? detail.splmQty : '-'} {detail.gdslsUnitCd}
                        <span className="text-color-secondary">
                            <span className="ml-3 mr-3">|</span>
                            {detail.specTxt}
                        </span>
                    </div>
                    <div className="col-12 pb-1 pt-3 flex text-xl font-bold text-color-blue">{t(tokens.common.expiration_date)} | {t(tokens.common.product_barcode)}</div>
                    {map(detail.shlfYmds, (ymd, index) => {
                        const lot = detail.lotNos?.[index] || ''; // LOT번호가 없을 경우 빈 문자열
                        return (
                            <div key={index} className="col-12 p-0 pl-2 flex text-md font-semibold">
                                {moment(ymd).format('YY-MM-DD')} | {lot}
                            </div>
                        )
                    })}
                </div>
                <div className="col-12 flex font-bold text-lg text-left ml-2 pt-3 pb-0">{t(tokens.inventory.location_info)}</div>
                {detail.lctScanTyp === 'DEST' ? (
                    <div className="card w-full m-2 mt-1 mb-1 p-1">
                        <div className="col-12 flex justify-content-between text-lg font-bold">
                            <div className="text-color-blue">{t(tokens.inventory.destination_location)}</div>
                            <div className="text-color-yellow">
                                {translateLocationType(detail.destLctTypCd, t)}
                            </div>
                        </div>
                        <div className="col-12 flex text-md pt-0">{`${
                            detail.destSectorNm + '' + detail.destBayId?.substring(1)
                        }-${detail.destRackRowId?.padStart(2, '0')}-${detail.destRackColId?.padStart(2, '0')}`}</div>
                    </div>
                ) : (
                    <div className="card w-full m-2 mt-1 mb-1 p-1">
                        <div className="col-12 flex justify-content-between text-lg font-bold">
                            <div className="text-color-blue">{t(tokens.inventory.origin_location)}</div>
                            <div className="text-color-yellow">
                                {translateLocationType(detail.destLctTypCd, t)}
                            </div>
                        </div>
                        <div className="col-12 flex text-md pt-0">{`${
                            detail.srcSectorNm + '' + detail.srcBayId?.substring(1)
                        }-${detail.srcRackRowId?.padStart(2, '0')}-${detail.srcRackColId?.padStart(2, '0')}`}</div>
                    </div>
                )}
            </div>
            <div className="absolute pda-bottom bottom-0 w-full z-auto">
                {detail.lctScanTyp === 'DEST' ? (
                    <Button
                        className="w-full p-button-info border-none bg-white"
                        label={t(tokens.common.scan_arrival_location)}
                        size="large"
                        text
                        outlined
                        severity="success"
                        onClick={onclickScanDestination}
                    />
                ) : (
                    <div>
                        <Button
                            className="p-button-info border-none bg-green-500 col-6 text-white"
                            label={t(tokens.common.scan_departure_location)}
                            size="large"
                            text
                            outlined
                            onClick={onclickScan}
                        />
                        <Button
                            className="p-button-info border-none bg-orange-400 col-6 text-white"
                            label={t(tokens.common.replenishment_cancellation)}
                            size="large"
                            text
                            outlined
                            onClick={onclickCancel}
                        />
                    </div>
                )}
            </div>
            <InventorySupplementQuantityDialog
                inventorySupplementDetail={detail}
                visible={supplementQuantityVisible}
                onHide={(e) => {
                    setSupplementQuantityVisible(false)
                    if (e) {
                        setTimeout(() => navigate(-1), 500)
                    }
                }}
                nextStep={(e) => {
                    detail.supplementGoodsQty = e
                    setSupplementQuantityVisible(false)
                    setScanVisible(true)
                }}
            />
            {/* 팝업 */}
            <InventorySupplementScanDialog
                detail={detail}
                visible={scanVisible}
                onHide={(e) => {
                    detail.supplementGoodsQty = undefined
                    setScanVisible(false)
                    if (e) {
                        setTimeout(() => navigate(-1), 500)
                    }
                }}
            />
        </div>
    )
}

export default InventorySupplementScan
